import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { Link, useLoaderData } from "react-router-dom";
import AuthProvider, { AuthContext } from "../../UserContext/AuthProvider";
import { FaStar, FaBook, FaFilePdf, FaUser, FaClock } from "react-icons/fa";
import { handleAdd } from "../../Checkout/Checkout";
import ReactPrint from 'react-to-print';
import {useRef} from 'react'
const CourseDetails = () => {
	const data = useLoaderData();
	const { allData } = useContext(AuthContext);
	const ref = useRef()
	const {
		name,
		price,
		id,
		author_name,
		author_img,
		img,
		Duration,
		Enrolled,
		Lessons,
		rating,
		details,
	} = data;
	return (
		<div className="container py-5">
			<div className="row">
				<div className="col-md-4">
					<div className="bg-black py-4 px-3 position-sticky top-0 text-white rounded">
						{allData.map((dataSingle) => (
							<Link
								key={dataSingle.id}
								className="text-decoration-none text-white fw-bold my-2 d-block"
								to={`/courses/${dataSingle.id}`}
							>
								{dataSingle.name}
							</Link>
						))}
					</div>
				</div>
				<div ref={ref} className="col-md-8">
					<img src={`/${img}`} alt="" />
					<div className="mt-3 mb-0 d-flex align-items-center">
                    <h2 className="fw-bolder">{name}</h2>
                    <ReactPrint content={() => ref.current} trigger={() => <button  className="bg-transparent ms-3 fs-3"><FaFilePdf></FaFilePdf></button>}></ReactPrint>
                    </div>
					<div className="d-flex fw-bold justify-content-between mt-3 px-2 py-3 d-flex">
						<div>
							<FaBook></FaBook> {Lessons}
						</div>
						<div>
							<FaUser></FaUser> {Enrolled}
						</div>
						<div>
							<FaClock></FaClock> {Duration}
						</div>
						<div>
							<FaClock></FaClock> {Duration}
						</div>
						<div>
							<FaStar></FaStar>
							<FaStar></FaStar>
							<FaStar></FaStar>
							<FaStar></FaStar>
							<FaStar className="me-2"></FaStar>
							{rating}
						</div>
					</div>
					<div className="mt-3 bg-black text-white d-inline-block rounded px-4 py-2">
						<div>
							<h1 className="fs-1 fw-bolder">Price: ${price}</h1>
						</div>
					</div>
					<div className="author-info mt-5 mb-3">
						<img
							src={`/${author_img}`}
							className="rounded-circle"
							width="60px"
							alt=""
						/>{" "}
						<span className="fw-bolder">{author_name}</span>
					</div>
					<div className="mt-4">
						<h3 className="fw-bolder">About the course</h3>
						{details.split(".").map((s) => (
							<p key={s} className="fw-bold mb-2">{s}</p>
						))}
					</div>
                    <Link  to="/checkout"><button onClick={() => handleAdd(id)} className="px-5 rounded fs-5 bg-black border-0 text-white fw-bolder mt-3 py-3">
                    Get premium access
                    </button></Link>
				</div>
			</div>
		</div>
	);
};

export default CourseDetails;
